/**
 * The browser's IANA time zone ("Asia/Kolkata"). Sent with every checkout
 * and price quote: the server's fair-pricing check compares it with the
 * country of the buyer's IP (a VPN moves the IP, almost never the clock).
 *
 * Dependency-free on purpose: the early checkout entry (checkoutEarly.ts)
 * imports it and must stay a few KB.
 */
export const buyerTimezone = (): string | undefined => {
	try {
		return Intl.DateTimeFormat().resolvedOptions().timeZone || undefined;
	} catch {
		return undefined;
	}
};
